import {isEmpty} from "../../../helpers/helpers";

//export const TileUrl = "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw";
export const TileUrl = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

export const defaultOption = {
    scrollWheelZoom: true,
    zoomControl: false,
    dragging: true,
    fullscreenControl: true,
    maxZoom: 18,
    attributionControl: false,
};

export const NeshanOptions = (center, zoom, customOptions) => {
    return {
        key: "web.MUx5GDjBmdvHWEWYwcm8vhVvFGj1aJBWD82kMmW8",
        maptype: "dreamy",
        scrollWheelZoom: !isEmpty(customOptions.scrollWheelZoom) ? customOptions.scrollWheelZoom : true,
        dragging: !isEmpty(customOptions.dragging) ? customOptions.dragging : true,
        traffic: false,
        center: center,
        zoom: zoom,
        maxZoom: !isEmpty(customOptions.maxZoom) ? customOptions.maxZoom : 18,
        zoomControl: false,
        fullscreenControl: !isEmpty(customOptions.fullscreenControl) ? customOptions.fullscreenControl : true,
    };
};

export const persianTranslation = {
    tooltips: {
        placeMarker: "برای قرار دادن نشانگر کلیک کنید",
        firstVertex: "برای قرار دادن اولین رأس کلیک کنید",
        continueLine: "برای ادامه‌ی ترسیم کلیک کنید",
        finishLine: "برای تکمیل هر نشانگر موجود کلیک کنید",
        finishPoly: "برای اتمام ترسیم روی اولین نشانگر کلیک کنید",
        finishRect: "برای پایان کلیک کنید",
        startCircle: "برای انتخاب مرکز کلیک کنید",
        finishCircle: "برای پایان حلقه کلیک کنید",
        placeCircleMarker: "برای قرار دادن نشانگر دایره‌ای کلیک کنید",
    },
};

export const polygonDrawOptions = {
    position: "topleft",
    drawMarker: false,
    drawCircleMarker: false,
    drawPolyline: false,
    drawRectangle: false,
    drawPolygon: false,
    drawCircle: false,
    editMode: false,
    dragMode: false,
    cutPolygon: false,
    removalMode: false,
    pinningOption: false,
    snappingOption: false,
};
